import { render } from "./routeCreate.vue?vue&type=template&id=29c98558&scoped=true"
import script from "./routeCreate.vue?vue&type=script&lang=js"
export * from "./routeCreate.vue?vue&type=script&lang=js"

import "./routeCreate.vue?vue&type=style&index=0&id=29c98558&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c98558"]])

export default __exports__